// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","568":"28455a0b"}[chunkId] + "-" + {"245":"5ef721fb8ebba85fcf69","568":"7bce6ccf15e255b763f4"}[chunkId] + ".js";
};